function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Design",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.465 283.465"
}, props), /*#__PURE__*/React.createElement("defs", null), /*#__PURE__*/React.createElement("path", {
  d: "M77.953 42.52H44.544L56.693 0 0 70.866h33.408l-12.148 42.52L77.953 42.52z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: styles["cls-1"] || "cls-1",
  cx: "106.316",
  cy: "218.419",
  rx: "9.936",
  ry: "9.822"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: styles["cls-1"] || "cls-1",
  cx: "177.149",
  cy: "218.419",
  rx: "9.936",
  ry: "9.822"
}), /*#__PURE__*/React.createElement("path", {
  d: "M223.937 63.855H113.386v35.476h56.693V92.2h53.858a31.217 31.217 0 0131.182 31.181v160.082h28.346V123.383a59.595 59.595 0 00-59.528-59.528z"
}), /*#__PURE__*/React.createElement("path", {
  className: styles["cls-1"] || "cls-1",
  d: "M223.897 136.814a24.785 24.785 0 00-24.772-23.534H84.338a24.78 24.78 0 00-24.773 23.508l-5.771 109.417a15.676 15.676 0 0015.656 16.468h1.416v20.792h28.347v-20.792h85.039v20.792h28.346v-20.792h1.417a15.675 15.675 0 0015.654-16.498zm-28.29 4.98l2.597 49.218H85.259l2.596-49.218zm4.873 92.365H82.983l1.511-28.647H198.97z"
})));